var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.rootClasses},[_c('div',{staticClass:"war-room-achievement__border-overlay"}),_vm._v(" "),_c('div',{staticClass:"war-room-achievement__container"},[_c('div',{staticClass:"war-room-achievement__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }